import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useExternalAmounts } from '@ff-os/shared-react/hooks/useExternalAmounts';
import {
    selectIsPremiumAvailable, selectPremiumSkuPairs
} from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { SURCHARGE_LABEL_KEY, toSurchargeInCents } from '@ff-scene-plugins/photo-prints-shared/premium/surcharge';

export const usePremiumSurchargeLabel = (): string | undefined => {

    const { t } = useTranslation();

    const isPremiumAvailable = useSelector(selectIsPremiumAvailable);
    const skuPairs = useSelector(selectPremiumSkuPairs);

    const pairs = isPremiumAvailable ? skuPairs : [];

    const amounts = useExternalAmounts(
        pairs.flatMap(({ sku, premiumSku }) => [sku, premiumSku])
    );

    const surcharge = amounts && toSurchargeInCents(pairs, amounts);

    if (surcharge === undefined) {
        return undefined;
    }

    return t(SURCHARGE_LABEL_KEY, {
        integerPart: String(Math.floor(surcharge / 100)),
        fractionPart: String(surcharge % 100).padStart(2, '0')
    });
};